const RHUMB_MARKS = ['mark_all_success', 'mark_all_failure'];
export const didRhumbAlreadyFire = () => RHUMB_MARKS.some(mark => window.performance.getEntriesByName(mark, 'mark').length > 0);
export function watchForRhumbMark(onMarkFired) {
  if (!window.PerformanceObserver || !window.performance) {
    return;
  }

  // No point in trying to aggregate if we're called post-rhumb-success/failure
  if (didRhumbAlreadyFire()) {
    return;
  }

  // eslint-disable-next-line compat/compat
  const observer = new PerformanceObserver(list => {
    for (const entry of list.getEntries()) {
      if (entry.entryType === 'mark' && RHUMB_MARKS.includes(entry.name)) {
        onMarkFired();
        observer.disconnect();
        break;
      }
    }
  });
  observer.observe({
    entryTypes: ['mark']
  });
}